import React, { useEffect } from "react";
import LoadCSSforfirstTime from "../../../../../../../CloudStorage/LoadCSSforfirstTime";
import { useParams } from "react-router-dom";
import { getPostsById } from "../../../../../../../redux/posts/action";
import { useDispatch, useSelector } from "react-redux";
import MineActiveContestOverview from "./MineActiveContestOverview";
import MineActiveContestMessagesFiles from "./MineActiveContestMessagesFiles";
import MineActiveContestTimesheet from "./MineActiveContestTimesheet";

export default function MineActiveContestAllTabs() {
  const { id } = useParams();
  const path = "Assets/scss/FindWork.module.scss";
  const dispatch = useDispatch();

  const posts = useSelector(({ posts: { postbyid } }) => postbyid);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  useEffect(() => {
    dispatch(getPostsById(id));
  }, [id]);
  return (
    <div className ="project-section">
      <h4
        
        data-toggle="tab"
        className ="nav-link active"
      >
        Website template & brand mockups design
      </h4>
      <div className ="col-12">
        <ul className ="nav nav-tabs">
          <li className ="nav-item">
            <a
              
              data-toggle="tab"
              className ="nav-link active"
            >
              Overview
            </a>
          </li>
          <li className ="nav-item">
            <a  data-toggle="tab" className ="nav-link ">
              Messages and files
            </a>
          </li>
          <li className ="nav-item">
            <a  data-toggle="tab" className ="nav-link ">
              Timesheet
            </a>
          </li>
        </ul>
        <div className ="tab-content">
          <div className ="tab-pane active" id="UmbrellaContests">
            <MineActiveContestOverview posts={posts} />
          </div>
          <div className ="tab-pane" id="message">
            <MineActiveContestMessagesFiles posts={posts} />
          </div>
          <div className ="tab-pane" id="timesheet">
            <MineActiveContestTimesheet posts={posts} />
          </div>
        </div>
      </div>
    </div>
  );
}
